import { render, staticRenderFns } from "./SaleCommissionList.vue?vue&type=template&id=6608f37a&"
import script from "./SaleCommissionList.vue?vue&type=script&lang=js&"
export * from "./SaleCommissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports